"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertOrderDetailOrder = exports.convertOrderStatus = exports.getPayButtonTitle = exports.isOrderInProgress = exports.setWaitTimeForOrder = exports.updateTimeSlot = exports.acceptDrinkLimitForOrder = exports.removePromoCodeFromOrder = exports.updatePaymentMethodForOrder = exports.updateTicketId = exports.updateDestinationForOrder = exports.updateTipForOrder = exports.removeItemFromOrder = exports.replaceItemInOrder = exports.addItemToOrder = exports.createDefaultOrder = exports.createDefaultTip = exports.getMinAndMaxDatesForPreorder = exports.getAPIParamsForOrder = exports.getAPIParamsForScheduledInfo = exports.getAPIParamsForTip = exports.validateOrder = exports.getOrderType = exports.isValidDeliveryDestination = exports.formatDateForOrderHistory = exports.formatTimeForOrderHistory = exports.getCartParams = exports.getTipAmountForOrder = exports.getDrinkOptionId = void 0;
const uuid_1 = require("uuid");
const types_1 = require("../types");
const globalTypes_1 = require("../globalTypes");
const constants_1 = require("../constants");
const date_1 = require("./date");
const timeSlot_1 = require("./timeSlot");
const cartUtils = require("./cart");
const drinks_1 = require("./drinks");
const destinationUtils = require("./destination");
const moneyUtils = require("./money");
const venueUtils = require("./venue");
const getDrinkOptionId = (option) => option.optionId;
exports.getDrinkOptionId = getDrinkOptionId;
const getTipAmountForOrder = (total, tip) => {
    if (tip.percent && tip.type === types_1.TipType.Percent) {
        const realPercent = tip.percent / 100;
        return moneyUtils.scale(total * realPercent);
    }
    else {
        return moneyUtils.scale(tip.amount || 0);
    }
};
exports.getTipAmountForOrder = getTipAmountForOrder;
const getCartParams = (cart) => {
    const params = {
        drinkId: cart.item.drinkId,
        drinkOptions: cart.options.map(exports.getDrinkOptionId),
        quantity: cart.quantity,
    };
    if (cart.comments) {
        params.comments = cart.comments;
    }
    return params;
};
exports.getCartParams = getCartParams;
const formatTimeForOrderHistory = (date) => {
    return constants_1.constants.DateFormats.genericTimeFormat(date);
};
exports.formatTimeForOrderHistory = formatTimeForOrderHistory;
const formatDateForOrderHistory = (date) => {
    return `${constants_1.constants.DateFormats.shortDateFormat(date)} • ${(0, exports.formatTimeForOrderHistory)(date)}`;
};
exports.formatDateForOrderHistory = formatDateForOrderHistory;
const isValidDeliveryDestination = (destination, fieldConfig) => {
    const { delivery } = destination;
    if (!fieldConfig) {
        return true;
    }
    const configByKey = fieldConfig.reduce((accum, val) => {
        accum[val.key] = val;
        return accum;
    }, {});
    if (!delivery.length || delivery.length !== fieldConfig.length) {
        return false;
    }
    return delivery.every((bit) => {
        const value = bit.value;
        if (!value) {
            return false;
        }
        const config = configByKey[bit.key];
        const isValid = !!value.match(new RegExp(config.regex));
        return isValid;
    });
};
exports.isValidDeliveryDestination = isValidDeliveryDestination;
const getOrderType = (order) => {
    let orderType = types_1.OrderType.Realtime;
    if (order.timeSlot && order.timeSlot !== 'immediate') {
        orderType = order.timeSlot.id || !(0, timeSlot_1.isFutureOrder)(order) ? types_1.OrderType.Scheduled : types_1.OrderType.PreOrder;
    }
    return orderType;
};
exports.getOrderType = getOrderType;
const DELIVERY_ERROR_TITLE = 'Signed, sealed, delivered. It’s yours.';
const DELIVERY_ERROR_MESSAGE = 'Before we can make and deliver your order, we need to know where you want your order ' +
    'delivered. Please enter a delivery location.';
const validateOrder = ({ order, paymentProcessor, fulfillmentCenter, requireTimeOption, }) => {
    var _a;
    const errors = [];
    if (!order.paymentMethod && paymentProcessor !== types_1.PaymentProcessor.Void) {
        errors.push(new types_1.ValidationError(types_1.OrderValidationErrorCode.PaymentMethodRequired, null, 'Please select a card or another payment method'));
    }
    if (destinationUtils.isDestinationDelivery(order.destination) &&
        order.destination.delivery.length === 0 &&
        ((_a = fulfillmentCenter.deliveryFields) === null || _a === void 0 ? void 0 : _a.length) !== 0) {
        errors.push(new types_1.ValidationError(types_1.OrderValidationErrorCode.NoDelivery, DELIVERY_ERROR_TITLE, DELIVERY_ERROR_MESSAGE));
    }
    if (!order.timeSlot && requireTimeOption) {
        errors.push(new types_1.ValidationError(types_1.OrderValidationErrorCode.PickupTimeRequired, 'Pick-up time required', 'Please select a pick-up time.'));
    }
    if (fulfillmentCenter.pickupLocations &&
        !destinationUtils.isDestinationDelivery(order.destination) &&
        !order.destination.pickupLocationId) {
        errors.push(new types_1.ValidationError(types_1.OrderValidationErrorCode.PickupLocationRequired, 'Pick-up location required', 'Please select a pick-up location.'));
    }
    return errors.length === 0 ? undefined : errors;
};
exports.validateOrder = validateOrder;
const getAPIParamsForTip = ({ venue, order, }) => {
    const cartTotal = cartUtils.getCartTotal(order.cart);
    let tipPercentage;
    if (venueUtils.isFeatureEnabled(venue, types_1.Feature.tip)) {
        tipPercentage = order.tip.percent;
    }
    let tip;
    if (venueUtils.isFeatureEnabled(venue, types_1.Feature.tip)) {
        tip = (0, exports.getTipAmountForOrder)(cartTotal, order.tip);
    }
    return {
        tip: tip !== null && tip !== void 0 ? tip : 0,
        tipPercentage,
    };
};
exports.getAPIParamsForTip = getAPIParamsForTip;
const getAPIParamsForScheduledInfo = (order) => {
    let timeSlotId = null;
    let scheduledTime = null;
    const orderType = (0, exports.getOrderType)(order);
    if (order.timeSlot && order.timeSlot !== 'immediate') {
        if (order.timeSlot.id) {
            timeSlotId = order.timeSlot.id;
        }
        else {
            scheduledTime = order.timeSlot.time;
        }
    }
    return {
        timeSlotId,
        scheduledTime,
        type: orderType,
    };
};
exports.getAPIParamsForScheduledInfo = getAPIParamsForScheduledInfo;
const getAPIParamsForOrder = ({ venue, fulfillmentCenter, order, total, }) => {
    var _a, _b, _c;
    const { cart } = order;
    const cartTotal = cartUtils.getCartTotal(order.cart);
    const { type, timeSlotId, scheduledTime } = (0, exports.getAPIParamsForScheduledInfo)(order);
    const { tip, tipPercentage } = (0, exports.getAPIParamsForTip)({ venue, order });
    const json = {
        cart: cart.map(exports.getCartParams),
        timeSlotId,
        amount: cartTotal,
        tip,
        tipPercentage,
        total,
        fulfillmentCenterId: fulfillmentCenter.id,
        scheduledTime,
        type,
        idempotencyKey: order.idempotencyKey,
        ticketId: order.ticketId,
        paymentMethodId: (_b = (_a = order.paymentMethod) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null,
    };
    if (destinationUtils.isDestinationDelivery(order.destination)) {
        json.delivery = order.destination.delivery.map((row) => {
            return {
                // __typename: 'DeliveryLocationInput',
                key: row.key,
                value: row.value,
            };
        });
    }
    else if (order.destination.pickupLocationId) {
        json.pickupLocationId = order.destination.pickupLocationId;
    }
    if ((_c = order.promoCode) === null || _c === void 0 ? void 0 : _c.code) {
        json.promoCode = order.promoCode.code;
    }
    return json;
};
exports.getAPIParamsForOrder = getAPIParamsForOrder;
const getMinAndMaxDatesForPreorder = () => {
    const min = new Date();
    return {
        min,
        max: new Date(min.getFullYear() + 1, min.getMonth() + 1),
    };
};
exports.getMinAndMaxDatesForPreorder = getMinAndMaxDatesForPreorder;
const createDefaultTip = (venue) => {
    var _a, _b;
    return {
        type: types_1.TipType.Percent,
        percent: (_b = (_a = venue.requiredTipPercentage) !== null && _a !== void 0 ? _a : venue.config.defaultTipPercentage) !== null && _b !== void 0 ? _b : 20,
        amount: null,
    };
};
exports.createDefaultTip = createDefaultTip;
const createDefaultOrder = (venue, fulfillmentCenter, item) => {
    const isDeliveryEnabled = fulfillmentCenter.delivery;
    const isPickupEnabled = fulfillmentCenter.pickup;
    const destination = isDeliveryEnabled && !isPickupEnabled
        ? {
            delivery: fulfillmentCenter.deliveryFields
                ? fulfillmentCenter.deliveryFields.map((field) => {
                    return {
                        key: field.key,
                        value: '',
                    };
                })
                : [],
        }
        : {
            pickupLocationId: null,
        };
    return {
        tip: (0, exports.createDefaultTip)(venue),
        status: types_1.OrderStatus.CREATED,
        destination,
        promoCode: null,
        paymentMethod: null,
        cart: item ? [item] : [],
        acceptedDrinkLimit: false,
        estimatedWaitTime: null,
        idempotencyKey: (0, uuid_1.v4)(),
        ticketId: null,
    };
};
exports.createDefaultOrder = createDefaultOrder;
const addItemToOrder = (order, item) => {
    const itemId = cartUtils.getIdForCartItem(item);
    const sameItem = order.cart.find((existingItem) => cartUtils.getIdForCartItem(existingItem) === itemId);
    if (sameItem) {
        const index = order.cart.indexOf(sameItem);
        const mergedItem = Object.assign(Object.assign({}, sameItem), { quantity: sameItem.quantity + item.quantity });
        return (0, exports.replaceItemInOrder)(order, index, mergedItem);
    }
    else {
        return Object.assign(Object.assign({}, order), { cart: order.cart.concat([item]) });
    }
};
exports.addItemToOrder = addItemToOrder;
const replaceItemInOrder = (order, index, item) => {
    const cart = order.cart.slice(0);
    cart.splice(index, 1, item);
    return Object.assign(Object.assign({}, order), { cart });
};
exports.replaceItemInOrder = replaceItemInOrder;
const removeItemFromOrder = (order, index) => {
    const cart = order.cart.slice(0);
    cart.splice(index, 1);
    return Object.assign(Object.assign({}, order), { cart });
};
exports.removeItemFromOrder = removeItemFromOrder;
const updateTipForOrder = (order, tip) => {
    return Object.assign(Object.assign({}, order), { tip });
};
exports.updateTipForOrder = updateTipForOrder;
const updateDestinationForOrder = (order, destination) => {
    return Object.assign(Object.assign({}, order), { destination });
};
exports.updateDestinationForOrder = updateDestinationForOrder;
const updateTicketId = (order, ticketId) => {
    return Object.assign(Object.assign({}, order), { ticketId });
};
exports.updateTicketId = updateTicketId;
const updatePaymentMethodForOrder = (order, paymentMethod) => {
    return Object.assign(Object.assign({}, order), { paymentMethod });
};
exports.updatePaymentMethodForOrder = updatePaymentMethodForOrder;
const removePromoCodeFromOrder = (order) => {
    return Object.assign(Object.assign({}, order), { promoCode: null });
};
exports.removePromoCodeFromOrder = removePromoCodeFromOrder;
const acceptDrinkLimitForOrder = (order) => {
    return Object.assign(Object.assign({}, order), { acceptedDrinkLimit: true });
};
exports.acceptDrinkLimitForOrder = acceptDrinkLimitForOrder;
const updateTimeSlot = (order, timeSlot) => {
    return Object.assign(Object.assign({}, order), { timeSlot });
};
exports.updateTimeSlot = updateTimeSlot;
const setWaitTimeForOrder = (order, estimatedWaitTime) => {
    return Object.assign(Object.assign({}, order), { estimatedWaitTime });
};
exports.setWaitTimeForOrder = setWaitTimeForOrder;
const isOrderInProgress = (order) => {
    return order.status !== types_1.OrderStatus.CREATED;
};
exports.isOrderInProgress = isOrderInProgress;
const getPayButtonTitle = (order, price) => {
    if ((0, timeSlot_1.isFutureOrder)(order)) {
        return 'SCHEDULE ORDER';
    }
    else if (order.status === types_1.OrderStatus.PREORDER) {
        return 'CONFIRM ORDER';
    }
    else {
        return `PAY - ${moneyUtils.formatAsPrice(price)}`;
    }
};
exports.getPayButtonTitle = getPayButtonTitle;
const convertOrderStatus = (status) => {
    switch (status) {
        case globalTypes_1.OrderStatus.Preorder:
            return types_1.OrderStatus.PREORDER;
        case globalTypes_1.OrderStatus.Created:
            return types_1.OrderStatus.CREATED;
        case globalTypes_1.OrderStatus.Paid:
        case globalTypes_1.OrderStatus.Scheduled:
            return types_1.OrderStatus.PAID;
        case globalTypes_1.OrderStatus.AwaitingPickup:
            return types_1.OrderStatus.AWAITING_PICKUP;
        case globalTypes_1.OrderStatus.Fulfilled:
            return types_1.OrderStatus.FULFILLED;
        case globalTypes_1.OrderStatus.Rejected:
            return types_1.OrderStatus.REJECTED;
        case globalTypes_1.OrderStatus.Refunded:
            return types_1.OrderStatus.REFUNDED;
        default:
            return types_1.OrderStatus.CREATED;
    }
};
exports.convertOrderStatus = convertOrderStatus;
const convertOrderDetailOrder = (orderDetailResponse, status = types_1.OrderStatus.CREATED) => {
    return {
        id: orderDetailResponse.id,
        cart: orderDetailResponse.cart.map((item) => {
            return {
                item: (0, drinks_1.trimMemuItemForCart)(item.item),
                options: item.options,
                quantity: item.quantity,
                comments: null,
            };
        }),
        tip: orderDetailResponse.venue.requiredTipPercentage
            ? (0, exports.createDefaultTip)(orderDetailResponse.venue)
            : orderDetailResponse.tip,
        promoCode: null,
        paymentMethod: null,
        orderNumber: undefined,
        destination: orderDetailResponse.deliveryLocation
            ? { delivery: orderDetailResponse.deliveryLocation }
            : { pickupLocationId: null },
        timeSlot: orderDetailResponse.scheduledTime
            ? {
                id: null,
                name: (0, date_1.formatInTimeZone)(new Date(orderDetailResponse.scheduledTime), 'genericTimeFormat', orderDetailResponse.venue.timezone),
                time: orderDetailResponse.scheduledTime,
            }
            : 'immediate',
        status,
        acceptedDrinkLimit: false,
        estimatedWaitTime: null,
        idempotencyKey: (0, uuid_1.v4)(),
        ticketId: orderDetailResponse.ticketId,
    };
};
exports.convertOrderDetailOrder = convertOrderDetailOrder;
//# sourceMappingURL=order.js.map